//-- Copyright (c) 2021 TMT Insights Group, LLC
import React from 'react';
import { useSnackbar } from 'notistack';
import PolarisIcon from './PolarisIcon';

// NOTE: add styles to SnackBar.tsx

const defaultOptions = {
  anchorOrigin: {
    vertical: 'top',
    horizontal: 'right'
  },
  iconVariant: {
    success: <PolarisIcon icon="complete_outline" />,
    warning: <PolarisIcon icon="error" />,
    info: <PolarisIcon icon="info" />,
    error: <PolarisIcon icon="error_circle" />
  }
  // autoHideDuration: null
};

export function useToast() {
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();

  const snackbarFn =
    (variant: 'error' | 'warning' | 'success' | 'info' | 'loading') =>
    (text: any, options: any = {}) => {
      const id = enqueueSnackbar(text, {
        variant,
        SnackbarProps: {
          onClick: () => closeSnackbar(id)
        },
        ...defaultOptions,
        ...options
      } as any);
      return id;
    };

  const error = snackbarFn('error');
  const warn = snackbarFn('warning');
  const info = snackbarFn('info');
  const success = snackbarFn('success');
  const load = snackbarFn('loading');

  return { error, warn, info, success, load, closeSnackbar };
}
